import { ConsumerRequestFilters, ConsumerRequestsResponse, TransferRequest } from"./types";
import { ApiEndpoints } from"@shared/api/api-endpoints";
import { cxApiClient } from"@shared/api/clients/apiClientFactory";

export const requestsApi = {
 getConsumerRequests: async (
  filters: ConsumerRequestFilters
 ): Promise<ConsumerRequestsResponse> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
   "consumerWeb",
   "consumer-request",
   (query) => {
    if (Array.isArray(filters.consumer_id)) {
      filters.consumer_id.forEach(id => query.push("consumer_id", id.toString()));
    } else if (filters.consumer_id) {
      query.push("consumer_id", filters.consumer_id.toString());
    }
    if (filters.remote_utility_id) query.push("remote_utility_id", filters.remote_utility_id.toString());
    if (filters.page) query.push("page", filters.page.toString());
    if (filters.limit) query.push("limit", filters.limit.toString());
    if (filters.request_type) query.push("request_type", filters.request_type);
    if (filters.search_data) query.push("search_data", filters.search_data);
    if (filters.status) query.push("status", filters.status);
    return query;
   }
  );
  const response = await cxApiClient.get(url);
  return response.data;
 },

 getRequestStatuses: async (): Promise<any> => {
  const url = ApiEndpoints.createUrl("cx", "choices/consumer_support_request_status_css");
  const response = await cxApiClient.get(url);
  return response.data;
 },

    createTransferRequest: async (
      formData: FormData
    ): Promise<TransferRequest> => {
      const url = ApiEndpoints.createUrl("cx", "consumer-transfer-request");
      const response = await cxApiClient.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    },
};
